import React from 'react';
import { IconProps } from '../types';

interface BaseIconProps extends IconProps {
  children: React.ReactNode;
  viewBox?: string;
  role?: string;
  'aria-hidden'?: boolean;
}

export const BaseIcon: React.FC<BaseIconProps> = ({
  className = '',
  size = 24,
  width,
  height,
  color = 'currentColor',
  onClick,
  children,
  viewBox = '0 0 24 24',
  role = 'img',
  'aria-hidden': ariaHidden = false,
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      role={role}
      aria-hidden={ariaHidden}
      style={{ cursor: onClick ? 'pointer' : 'inherit' }}
    >
      {children}
    </svg>
  );
};

export default BaseIcon;
